import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Send, CheckCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { API_BASE as API } from '../lib/apiBase';


export default function AccessRequestPage() {
  const { lang } = useLang();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const requestLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/auth/request-access-link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, app_origin: window.location.origin })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Error');
      }
      setDone(true);
    } catch (err) {
      setError(err.message || 'Error');
    }
    setLoading(false);
  };

  return (
    <div data-testid="access-request-page" className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/login" data-testid="back-to-login-link" className="inline-flex items-center gap-2 text-pulse-muted text-sm mb-6 hover:text-white transition-colors">
          <ArrowLeft size={16} /> {lang === 'es' ? 'Volver al acceso' : 'Back to access'}
        </Link>

        <div className="bg-pulse-surface border border-pulse-border rounded-2xl p-8">
          <h1 className="font-heading font-bold text-2xl text-center">{lang === 'es' ? 'Primera sesión' : 'First access'}</h1>
          <p className="text-sm text-pulse-muted text-center mt-2">
            {lang === 'es'
              ? 'Te enviaremos un enlace seguro para verificar tu cuenta y crear tu contraseña.'
              : 'We will send you a secure link to verify your account and create your password.'}
          </p>

          {done ? (
            <div data-testid="access-request-success" className="mt-8 text-center space-y-4">
              <div className="w-16 h-16 rounded-full bg-green-500/15 flex items-center justify-center mx-auto">
                <CheckCircle size={30} className="text-green-400" />
              </div>
              <p className="text-sm">
                {lang === 'es'
                  ? 'Si tu acceso está listo, recibirás el enlace por email en unos minutos.'
                  : 'If your access is ready, you will receive the email link shortly.'}
              </p>
            </div>
          ) : (
            <form onSubmit={requestLink} className="space-y-4 mt-8">
              <div className="relative">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-pulse-muted" />
                <input
                  data-testid="access-request-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className="w-full bg-pulse-elevated border border-pulse-border rounded-xl pl-11 pr-4 py-3 text-sm focus:ring-2 focus:ring-cyan-500 focus:outline-none"
                />
              </div>
              {error && <p data-testid="access-request-error" className="text-red-400 text-xs">{error}</p>}
              <button
                data-testid="access-request-submit"
                type="submit"
                disabled={loading}
                className="w-full bg-pulse-primary text-black py-3 rounded-xl font-bold text-sm disabled:opacity-50 flex items-center justify-center gap-2"
              >
                <Send size={16} />
                {loading ? '...' : (lang === 'es' ? 'Enviar enlace seguro' : 'Send secure link')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}